import { CURRENCIES } from '@/mocks/marketCalendar';
import { CurrencyFlag } from './ui';

export default function MyMarketWatch({
  watchList,
  toggleWatch,
}: {
  watchList: string[];
  toggleWatch: (code: string) => void;
}) {
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="font-display text-xl font-bold tracking-tight text-slate-900 md:text-2xl">
            My Market Watch
          </h2>
          <p className="mt-1.5 text-sm text-slate-500">
            Chọn các thị trường bạn quan tâm để ưu tiên hiển thị sự kiện liên quan.
          </p>
        </div>
        <span className="hidden rounded-full bg-slate-100 px-3 py-1 text-[11px] font-medium text-slate-500 sm:inline-flex">
          Lưu tự động trên trình duyệt
        </span>
      </div>

      <div className="mt-5 flex flex-wrap gap-2">
        {CURRENCIES.map((c) => {
          const active = watchList.includes(c.code);
          return (
            <button
              key={c.code}
              type="button"
              onClick={() => toggleWatch(c.code)}
              className={`flex items-center gap-1.5 rounded-xl border px-3 py-2 text-sm font-semibold transition-all ${
                active
                  ? 'border-violet-600 bg-violet-50 text-violet-700'
                  : 'border-slate-200 bg-white text-slate-600 hover:border-violet-300'
              }`}
            >
              <CurrencyFlag code={c.code} />
              {c.code}
              {active && <i className="ri-check-line text-violet-600" />}
            </button>
          );
        })}
      </div>

      {watchList.length === 0 && (
        <p className="mt-4 text-xs text-slate-400">Chưa có thị trường nào được chọn. Chọn ít nhất một đồng tiền để bắt đầu.</p>
      )}
    </section>
  );
}